import React from 'react';

import LocalizedLink from 'components/LocalizedLink';
import LegalPageLayout from 'components/LegalPageLayout';
import { useI18n } from 'i18n/I18nContext';

const TermsPage = () => {
  const { t } = useI18n();

  return (
    <LegalPageLayout title={t('terms.title')}>
      <p className="mb-25">{t('terms.intro')}</p>
      <p className="mb-25 opacity-75 text-xs">{t('terms.notice')}</p>

      <h2 className="text-lg font-bold mt-40 mb-15">{t('terms.s1')}</h2>
      <p className="mb-25">{t('terms.s1Body')}</p>

      <h2 className="text-lg font-bold mt-40 mb-15">{t('terms.s2')}</h2>
      <p className="mb-25">{t('terms.s2Body')}</p>

      <h2 className="text-lg font-bold mt-40 mb-15">{t('terms.s3')}</h2>
      <p className="mb-25">{t('terms.s3Body')}</p>

      <h2 className="text-lg font-bold mt-40 mb-15">{t('terms.s4')}</h2>
      <p className="mb-25">{t('terms.s4Body')}</p>

      <h2 className="text-lg font-bold mt-40 mb-15">{t('terms.s5')}</h2>
      <p className="mb-25">
        {t('terms.s5Before')}{' '}
        <LocalizedLink className="text-green font-bold no-underline" to="/privacy">
          {t('footer.privacy')}
        </LocalizedLink>
        {t('terms.s5After')}
      </p>

      <h2 className="text-lg font-bold mt-40 mb-15">{t('terms.s6')}</h2>
      <p className="mb-25">{t('terms.s6Body')}</p>

      <h2 className="text-lg font-bold mt-40 mb-15">{t('terms.s7')}</h2>
      <p className="mb-25">{t('terms.s7Body')}</p>

      <h2 className="text-lg font-bold mt-40 mb-15">{t('terms.s8')}</h2>
      <p className="mb-25">
        {t('terms.s8Before')}{' '}
        <LocalizedLink className="text-green font-bold no-underline" to="/contact">
          {t('footer.contact')}
        </LocalizedLink>{' '}
        {t('terms.s8After')}
      </p>
    </LegalPageLayout>
  );
};

export default TermsPage;



// WEBPACK FOOTER //
// ./src/pages/TermsPage.tsx